// src/slices/ticketRecall/thunk.ts
// Async thunks cho phân hệ Thu hồi vé ế (mục 13.3, REQUIRE_FIXBUGS.md)

import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getTicketRecallsApi,
  createTicketRecallApi,
  confirmTicketRecallApi,
  cancelTicketRecallApi,
} from 'helpers/fakebackend_helper';
import { CreateTicketRecallPayload } from 'pages/TicketRecall/types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('ticket_recall_messages');

interface FetchTicketRecallsParams {
  pageIndex?: number;
  pageSize?: number;
  planId?: number | string;
  // '0' = chỉ phiếu thu hồi từ kho tổng, '<id>' = chỉ phiếu của đại lý đó, bỏ trống = tất cả.
  agentId?: number | string;
  status?: number | string;
}

// Loại bỏ param rỗng để không gửi query thừa lên API Gateway (tránh lỗi ép "undefined" thành
// chuỗi khi truyền thẳng vào query string — xem REQUIRE_FIXBUGS.md mục 13.1)
const cleanParams = (params: any): any => {
  const cleaned: any = {};
  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== '') {
      cleaned[key] = value;
    }
  });
  return cleaned;
};

export const fetchTicketRecalls = createAsyncThunk(
  'TicketRecall/fetchList',
  async (params: FetchTicketRecallsParams, { rejectWithValue }) => {
    try {
      const response = await getTicketRecallsApi(cleanParams(params));
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('khong_the_tai_danh_sach_phieu_message'));
    }
  },
);

export const createTicketRecall = createAsyncThunk(
  'TicketRecall/create',
  async (data: CreateTicketRecallPayload, { rejectWithValue }) => {
    try {
      const response = await createTicketRecallApi(data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('khong_the_lap_phieu_thu_hoi_message'));
    }
  },
);

export const confirmTicketRecall = createAsyncThunk(
  'TicketRecall/confirm',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await confirmTicketRecallApi(id);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('khong_the_xac_nhan_thu_hoi_message'));
    }
  },
);

export const cancelTicketRecall = createAsyncThunk(
  'TicketRecall/cancel',
  async ({ id, reason }: { id: number; reason?: string }, { rejectWithValue }) => {
    try {
      const response = await cancelTicketRecallApi(id, reason);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(error?.message || st('khong_the_huy_phieu_thu_hoi_message'));
    }
  },
);
